import {
  BackendApiClientPaths,
  ServiceInfoApiClientPaths,
} from "@/manager/backend-api-client/types";
import { clientEnvModule } from "@/modules/client-env";
import { VITE_LOCAL_BACKEND_API_BASE_URL } from "@/modules/global-state/globalEnv";
import createClient from "openapi-fetch";

const CANONICAL_BACKEND_API_ORIGIN = "https://api.mem.ai";
const CANONICAL_BACKEND_API_BASE_URL = `${CANONICAL_BACKEND_API_ORIGIN}/api`;

const getLocalBackendApiBaseUrl = () =>
  (VITE_LOCAL_BACKEND_API_BASE_URL || "http://localhost:8000").replace(/\/+$/, "");

export const getBackendBaseUrl = () => {
  const localBackendApiIsEnabled = clientEnvModule.localBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return `${getLocalBackendApiBaseUrl()}/api`;
  }

  return CANONICAL_BACKEND_API_BASE_URL;
};

export const getBackendAuthBaseUrl = () => {
  if (clientEnvModule.localBackendApiIsEnabled()) {
    return `${getLocalBackendApiBaseUrl()}/api`;
  }

  return CANONICAL_BACKEND_API_BASE_URL;
};

export const getBackendHealthCheckUrl = () => `${getBackendBaseUrl()}/v2/health`;

export const getBackendAnalyticsBaseUrl = () => {
  const localBackendApiIsEnabled = clientEnvModule.localBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return `${getLocalBackendApiBaseUrl()}/api`;
  }

  return CANONICAL_BACKEND_API_ORIGIN;
};

const getServiceInfoBaseUrl = () => {
  if (clientEnvModule.localBackendApiIsEnabled()) {
    return getLocalBackendApiBaseUrl();
  }

  return CANONICAL_BACKEND_API_ORIGIN;
};

export const getBackendAssetProxyUrl = () => {
  const isProd = clientEnvModule.isProd();
  const localBackendApiIsEnabled = clientEnvModule.localBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return `${getLocalBackendApiBaseUrl()}/api/v2/assets/proxy`;
  }

  if (isProd) {
    // Note that the `www` prefix is required.
    return "https://www.mem.storage/proxy";
  }

  /**
   * Note that for now, we actually always just return the
   * production endpoint.
   */
  return "https://www.mem.storage/proxy";
};

export const initializeBackendApiClient = () => {
  const baseUrl = getBackendBaseUrl();

  const apiClient = createClient<BackendApiClientPaths>({
    baseUrl,
  });

  return apiClient;
};

export const initializeBackendAuthApiClient = () => {
  const baseUrl = getBackendAuthBaseUrl();

  const apiClient = createClient<BackendApiClientPaths>({
    baseUrl,
  });

  return apiClient;
};

export const initializeServiceInfoApiClient = () => {
  return createClient<ServiceInfoApiClientPaths>({
    baseUrl: getServiceInfoBaseUrl(),
  });
};
